<div class="container-page">
    <h3 class="title">{{ 'core.privacyPolicy.title' | translate }}</h3>

    <p>{{ 'core.privacyPolicy.intro' | translate }}</p>

    <!-- Coleta de informações -->
    <h4 class="subtitle">{{ 'core.privacyPolicy.sections.collection.title' | translate }}</h4>
    <p class="topic">
        <strong>{{ 'core.privacyPolicy.sections.collection.personalInfoHeading' | translate }} </strong>
        <span>{{ 'core.privacyPolicy.sections.collection.personalInfoBody' | translate }}</span>
    </p>
    <p class="topic">
        <strong>{{ 'core.privacyPolicy.sections.collection.usageInfoHeading' | translate }} </strong>
        <span>{{ 'core.privacyPolicy.sections.collection.usageInfoBody' | translate }}</span>
    </p>

    <!-- Uso de informações -->
    <h4 class="subtitle">{{ 'core.privacyPolicy.sections.usage.title' | translate }}</h4>
    <p class="topic">{{ 'core.privacyPolicy.sections.usage.intro' | translate }}</p>
    <p class="topic">
        <strong>{{ 'core.privacyPolicy.sections.usage.item1' | translate }}</strong>
    </p>
    <p class="topic">
        <strong>{{ 'core.privacyPolicy.sections.usage.item2' | translate }}</strong>
    </p>
    <p class="topic">
        <strong>{{ 'core.privacyPolicy.sections.usage.item3' | translate }}</strong>
    </p>
    
    <!-- Compartilhamento de informações -->
    <h4 class="subtitle">{{ 'core.privacyPolicy.sections.sharing.title' | translate }}</h4>
    <p class="topic">{{ 'core.privacyPolicy.sections.sharing.body' | translate }}</p>
    
    <!-- Segurança das informações -->
    <h4 class="subtitle">{{ 'core.privacyPolicy.sections.security.title' | translate }}</h4>
    <p class="topic">{{ 'core.privacyPolicy.sections.security.body' | translate }}</p>
    
    <!-- Seus direitos -->
    <h4 class="subtitle">{{ 'core.privacyPolicy.sections.rights.title' | translate }}</h4>
    <p class="topic">{{ 'core.privacyPolicy.sections.rights.body' | translate }}</p>
    
    <!-- Alterações nesta Política de Privacidade -->
    <h4 class="subtitle">{{ 'core.privacyPolicy.sections.changes.title' | translate }}</h4>
    <p class="topic">{{ 'core.privacyPolicy.sections.changes.body' | translate }}</p>
    
    <!-- Contato -->
    <h4 class="subtitle">{{ 'core.privacyPolicy.sections.contact.title' | translate }}</h4>
    <p class="topic">
        {{ 'core.privacyPolicy.sections.contact.bodyBeforeEmail' | translate }}
        <a [href]="'mailto:' + ('core.privacyPolicy.sections.contact.email' | translate)">{{ 'core.privacyPolicy.sections.contact.email' | translate }}</a>.
    </p>

    <h6 class="subtitle">
        <strong>{{ 'core.privacyPolicy.lastUpdated' | translate }}</strong>
    </h6>
</div>
